<template>
  <div class="details-wrapper">
    <div class="details-header">
      <div class="back-icon-bg" @click="() => $emit('back')">
        <AssetV3
          dir="icons"
          name="solid-arrow-left.svg"
        />
      </div>
      <h3 class="gray-700">Resumo da proposta</h3>
    </div>

    <div class="details-body">
      <p class="details-title">
        Proposta
      </p>
      <p class="details-value">
        {{ proposalId }}
      </p>

      <p class="details-title">
        Código do título
      </p>
      <p class="details-value">
        {{ titleId }}
      </p>

      <p class="details-title">
        Locatário
      </p>
      <p class="details-value">
        {{ name }}
      </p>

      <p class="details-title">
        CPF
      </p>
      <p class="details-value">
        {{ cpf | cpfFilter }}
      </p>

      <p class="details-title">
        Celular
      </p>
      <p class="details-value">
        {{ phone | phoneFilter }}
      </p>
    </div>
  </div>
</template>

<script>
import stringMixin from '@/mixins/string';
import AssetV3 from '@/components/common/AssetV3.vue';

export default {
  name: 'proposalDetails',
  mixins: [stringMixin],
  components: {
    AssetV3,
  },
  data: () => ({
    proposalId: '0809235',
    titleId: '09817665',
    name: 'Fernando Alves Ribeiro',
    cpf: '99999999900',
    phone: '21988980988',
  }),
};
</script>

<style lang="scss" scoped>
  .details-wrapper {
    margin: 20px 24px;
  }

  .details-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .back-icon-bg {
    box-sizing: border-box;
    padding: 8px;
    width: 36px;
    height: 36px;
    border-radius: 8px;
    border: 1px solid var(--gray-200);
  }

  .details-body {
    margin-top: 28px;
  }

  .details-title {
    @extend .body-regular;
    color: var(--gray-700);
    margin-top: 16px;
  }

  .details-value {
    @extend .body-bold;
    color: var(--gray-700);
  }
</style>
